<template>
  <div class="measurement-container">
    <MeasurementsSmall v-if="showSmallMeasurements" v-bind="$props" />
    <MeasurementsLarge v-else v-bind="$props" />
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'
import MeasurementsLarge from './layouts/measurementsLarge.vue'
import MeasurementsSmall from './layouts/measurementsSmall.vue'
import { NAMESPACES } from '@/store/types'
import { DEVICE_GETTERS } from '@/store/devices'
import { DEVICE_MODELS_GETTERS } from '@/store/devicemodels'
import type { GetterByDeviceId, GetterByModelSubmodel } from '@/components/devicePopover/types'
import type { SensorReadings } from '@/services/device-service/devices'

const smallOnlyReadings = [6, 7, 8, 9, 10, 11, 12, 13]

export default defineComponent({
  name: 'popoverMeasurements',
  props: {
    deviceId: { type: String, default: '' },
    permissions: { type: Array as PropType<string[]>, default: (): string[] => [] },
    sensorReadings: { type: Object as PropType<SensorReadings>, default: null }
  },
  components: {
    MeasurementsLarge,
    MeasurementsSmall
  },
  computed: {
    model(): string {
      const getter = this.$store.getters[
        `${NAMESPACES.DEVICES}/${DEVICE_GETTERS.GET_MODEL_BY_DEVICE_ID}`
      ] as GetterByDeviceId<string>
      return getter(this.deviceId)
    },
    submodel(): string {
      const getter = this.$store.getters[
        `${NAMESPACES.DEVICES}/${DEVICE_GETTERS.GET_SUBMODEL_BY_DEVICE_ID}`
      ] as GetterByDeviceId<string>
      return getter(this.deviceId)
    },
    supportedMeasurements(): number[] {
      const getter = this.$store.getters[
        `${NAMESPACES.DEVICE_MODELS}/${DEVICE_MODELS_GETTERS.GET_SUPPORTED_MEASUREMENTS}`
      ] as GetterByModelSubmodel<number[]>
      return getter(this.model, this.submodel)
    },
    showSmallMeasurements(): boolean {
      if (!this.sensorReadings) {
        return false
      }
      return this.supportedMeasurements.some((r) => smallOnlyReadings.includes(r))
    }
  }
})
</script>

<style lang="scss" scoped>
.measurement-container {
  margin-top: -4px;
  margin-bottom: 8px;
  margin-left: 8px;
}
</style>
